export default class CheatsManager {

    // static

    private static firstInstance: CheatsManager | null = null;

    public static getFirstInstance(): CheatsManager | null {
        return this.firstInstance;
    }

    // instance

    private cheatsEnabled: boolean = false;

    private enableCheatsFunc: null | (() => void);

    private ignoreCardMatchRules: boolean = false;

    constructor(params: {
        autoEnableCheats: boolean,
        enableCheatsFunc: () => void,
    }) {
        if (CheatsManager.firstInstance === null) {
            CheatsManager.firstInstance = this;
        }

        this.enableCheatsFunc = params.enableCheatsFunc;
        if (params.autoEnableCheats) {
            this.enableCheats();
            // Not doing this in `this.enableCheats` to preserve original behavior
            // E.g. if we track who used cheats by detecting calls to GameCheats functions,
            // this won't be detected while still being a cheat
            this.enableMatchAnyCardCheat();
        } else {
            this.addKonamiInputListener();
        }
    }

    private enableCheats() {
        if (this.cheatsEnabled) return;

        this.cheatsEnabled = true;

        const enableCheats = this.enableCheatsFunc;
        this.enableCheatsFunc = null;
        enableCheats();
    }

    private addKonamiInputListener() {

        if (this.cheatsEnabled) return;

        const konami: string = '38384040373937396665';

        let input = '';

        const onKeyUp = (event: KeyboardEvent) => {
            if (this.cheatsEnabled) {
                removeListener();
                return;
            }
            input += event.keyCode;
            if (input !== konami.substr(0, input.length)) {
                input = '';
            } else if (input === konami) {
                console.log('\n' + [
                    '**********************************************************************',
                    '*************************** CHEATS ENABLED ***************************',
                    '**********************************************************************',
                ].join('\n'));
                removeListener();
                this.enableCheats();
            }
        };

        addListener();

        return removeListener;

        function addListener() {
            window.addEventListener('keyup', onKeyUp);
        }

        function removeListener() {
            window.removeEventListener('keyup', onKeyUp);
        }
    }

    public shouldIgnoreCardMatchRules() {
        return this.ignoreCardMatchRules;
    }

    private enableMatchAnyCardCheat() {
        const updateIgnoreCardMatchRules = (e: KeyboardEvent) => {
            this.ignoreCardMatchRules = e.shiftKey;
        };
        window.addEventListener('keydown', updateIgnoreCardMatchRules);
        window.addEventListener('keyup', updateIgnoreCardMatchRules);
    }
}
